import type { AccountMetricView, SpendingSummaryView } from '../account-detail.model';
import type { AccountDetailKind } from '../account-path-type';

const LOAN_COMPACT_LABELS = new Set(['Loan balance', 'APR', 'Term']);

function shortenLabel(label: string): string {
  switch (label) {
    case 'Available balance':
      return 'Balance';
    case 'Auto-savings':
      return 'Auto-save';
    case 'Auto-save amount':
      return 'Amount';
    case 'Balance due':
      return 'Due';
    case 'Loan balance':
      return 'Balance';
    default:
      return label;
  }
}

function compactRow(label: string, value: string): AccountMetricView {
  return { label: shortenLabel(label), value };
}

/** Sticky-header metrics after the full summary scrolls away. No linked accounts. */
export function compactHeaderMetrics(
  kind: AccountDetailKind,
  spending: SpendingSummaryView | null,
  savingsMetrics: AccountMetricView[] | null,
  debt: AccountMetricView[] | null,
  loan: AccountMetricView[] | null
): AccountMetricView[] {
  if (kind === 'checking' && spending) {
    const card = spending.cards[0];
    return [
      compactRow('Available balance', spending.availableBalance),
      {
        label: 'Debit',
        value: card ? `${card.chipLabel} ${card.last4Label}` : 'Not available',
      },
    ];
  }
  if (kind === 'savings' && savingsMetrics) {
    return savingsMetrics.map((metric) => compactRow(metric.label, metric.value));
  }
  if (kind === 'debt' && debt) {
    return debt.map((metric) => compactRow(metric.label, metric.value));
  }
  if (kind === 'loan' && loan) {
    return loan
      .filter((metric) => LOAN_COMPACT_LABELS.has(metric.label))
      .map((metric) => compactRow(metric.label, metric.value));
  }
  return [];
}
